import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=b5b178cc&scoped=true&"
import script from "./Catalogo.vue?vue&type=script&lang=js&"
export * from "./Catalogo.vue?vue&type=script&lang=js&"
import style0 from "./Catalogo.scss?vue&type=style&index=0&id=b5b178cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b178cc",
  null
  
)

export default component.exports